// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media screen and (max-width: 767px) {

  .transaction-stats-section {
    padding-top: 50px !important;
    padding-bottom: 50px !important;
  }

  .stats-container {
    margin-top: 20px !important;
    margin-bottom: 20px !important;
  }

  .stats-heading {
    font-size: 24px !important;
    line-height: 32px !important;
  }

  .stats-subheading {
    font-size: 15px !important;
    padding: 0 10px;
    margin-bottom: 30px !important;
  }

  .stats-column {
    padding-left: 8px !important;
    padding-right: 8px !important;
  }

  .stats-card {
    min-height: 220px !important;
    border-radius: 16px !important;
    padding: 20px 12px !important;
  }

  .stats-card h3 {
    font-size: 22px !important;
  }

  .stats-card .text-uppercase {
    font-size: 13px !important;
  }

  .stats-card .small {
    font-size: 12px !important;
  }
}

@media screen and (max-width: 480px) {

  .stats-heading {
    font-size: 22px !important;
  }

  .stats-subheading {
    font-size: 14px !important;
  }

  .stats-card {
    min-height: 200px !important;
    padding: 18px 10px !important;
  }

  .stats-card h3 {
    font-size: 18px !important;
  }

  .stats-card .text-uppercase {
    font-size: 12px !important;
  }

  .stats-card .small {
    font-size: 11px !important;
  }
}

@media screen and (min-width: 768px) and (max-width: 991px) {

  .stats-heading {
    font-size: 28px !important;
  }

  .stats-card {
    min-height: 260px !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/TransactionStats.css"],"names":[],"mappings":"AAAA;;EAEE;IACE,4BAA4B;IAC5B,+BAA+B;EACjC;;EAEA;IACE,2BAA2B;IAC3B,8BAA8B;EAChC;;EAEA;IACE,0BAA0B;IAC1B,4BAA4B;EAC9B;;EAEA;IACE,0BAA0B;IAC1B,eAAe;IACf,8BAA8B;EAChC;;EAEA;IACE,4BAA4B;IAC5B,6BAA6B;EAC/B;;EAEA;IACE,4BAA4B;IAC5B,8BAA8B;IAC9B,6BAA6B;EAC/B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA;;EAEE;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,4BAA4B;IAC5B,6BAA6B;EAC/B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA;;EAEE;IACE,0BAA0B;EAC5B;;EAEA;IACE,4BAA4B;EAC9B;AACF","sourcesContent":["@media screen and (max-width: 767px) {\r\n\r\n  .transaction-stats-section {\r\n    padding-top: 50px !important;\r\n    padding-bottom: 50px !important;\r\n  }\r\n\r\n  .stats-container {\r\n    margin-top: 20px !important;\r\n    margin-bottom: 20px !important;\r\n  }\r\n\r\n  .stats-heading {\r\n    font-size: 24px !important;\r\n    line-height: 32px !important;\r\n  }\r\n\r\n  .stats-subheading {\r\n    font-size: 15px !important;\r\n    padding: 0 10px;\r\n    margin-bottom: 30px !important;\r\n  }\r\n\r\n  .stats-column {\r\n    padding-left: 8px !important;\r\n    padding-right: 8px !important;\r\n  }\r\n\r\n  .stats-card {\r\n    min-height: 220px !important;\r\n    border-radius: 16px !important;\r\n    padding: 20px 12px !important;\r\n  }\r\n\r\n  .stats-card h3 {\r\n    font-size: 22px !important;\r\n  }\r\n\r\n  .stats-card .text-uppercase {\r\n    font-size: 13px !important;\r\n  }\r\n\r\n  .stats-card .small {\r\n    font-size: 12px !important;\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 480px) {\r\n\r\n  .stats-heading {\r\n    font-size: 22px !important;\r\n  }\r\n\r\n  .stats-subheading {\r\n    font-size: 14px !important;\r\n  }\r\n\r\n  .stats-card {\r\n    min-height: 200px !important;\r\n    padding: 18px 10px !important;\r\n  }\r\n\r\n  .stats-card h3 {\r\n    font-size: 18px !important;\r\n  }\r\n\r\n  .stats-card .text-uppercase {\r\n    font-size: 12px !important;\r\n  }\r\n\r\n  .stats-card .small {\r\n    font-size: 11px !important;\r\n  }\r\n}\r\n\r\n@media screen and (min-width: 768px) and (max-width: 991px) {\r\n\r\n  .stats-heading {\r\n    font-size: 28px !important;\r\n  }\r\n\r\n  .stats-card {\r\n    min-height: 260px !important;\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
